import { render, staticRenderFns } from "./ReporteVendidoXFechaI.vue?vue&type=template&id=4fb4d796&scoped=true"
import script from "./ReporteVendidoXFechaI.vue?vue&type=script&lang=js"
export * from "./ReporteVendidoXFechaI.vue?vue&type=script&lang=js"
import style0 from "./ReporteVendidoXFechaI.vue?vue&type=style&index=0&id=4fb4d796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb4d796",
  null
  
)

export default component.exports